import customCheckboxRadioSwitch from '../../../../assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx'

const dailyWashStyle = theme => ({
  ...customCheckboxRadioSwitch
})

export default dailyWashStyle
